import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const FileUnsupported = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M9.5 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v5'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M16.5 22a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.996-6.328a.588.588 0 0 0-.832.832l.996.996-.996.996a.588.588 0 0 0 .832.832l.996-.996.996.996a.588.588 0 0 0 .832-.832l-.996-.996.996-.996a.588.588 0 0 0-.832-.832l-.996.996z'
          fill='currentColor'
        />
      </>
    ) : (
      <>
        <path
          d='M3 0a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h4.81A6.5 6.5 0 0 1 16 10.022V3a3 3 0 0 0-3-3z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12.5 20a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.996-6.328a.588.588 0 0 0-.832.832l.996.996-.996.996a.588.588 0 0 0 .832.832l.996-.996.996.996a.588.588 0 0 0 .832-.832l-.996-.996.996-.996a.588.588 0 0 0-.832-.832l-.996.996z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
